export const MODULE_RISK_ZONES = "risk_zones"
export const MODULE_INCIDENTS = "incidents"
export const MODULE_SPEEDINGS = "speedings"
export const MODULES_SAFETY = [MODULE_RISK_ZONES, MODULE_INCIDENTS, MODULE_SPEEDINGS]